import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";
import { Player } from 'video-react';

import VideoIntroVR from '../../images/movies/wmgr_vr_flythrough.mp4';


class HowItWorks extends Component {
  render() {
    return (
        <div className="page_container">

    

      <Player>
      <source src={VideoIntroVR} />
    </Player>


      <div className="banner_callout howitworks">
      <div className="banner_callout_gradient">
          <div className="banner_callout_text">
      WMGR is a unique healthcare ecosystem, integrating the latest technology from all fields to provide a new platform of personalized health and wellbeing and leveraging global intelligence.
      </div>
      </div>
      </div>


      <div className="banner flow"/>



</div>
    );
  }
}

export default HowItWorks;

/*

  <div className="container mit">
    <div className="container_message" >
    <div className="content_text_title">Leading Research Collaboration</div>
    <div className="content_text">
    <img className="content_image" src={kit}/>
    WMGR is a wellness innovation company bringing together the best technologies and global data to improve quality of life and longevity.
    </div> 
    <Button className="button_learn_more" intent="primary" icon="chevron-right">Learn More</Button>
    </div>
  </div>
*/